import React from 'react';
import { ExportOnDemandButton } from '@scheduling/components';
import { AddButton, Icon, Link } from '@common/components';
import { Dropdown, Space } from 'antd';
import { buildDialogUrl } from '@common/services';
import { useFeatureFlags } from '@common/contexts';
import { useNavigate } from '@common/hooks';

interface Props {
  canCreateWorkers: boolean;
  canUploadWorkers: boolean;
  onAddStaffButtonClick: () => void;
  exportButton?: boolean;
  disabled?: boolean;
  loading?: boolean;
  exportFilters?: object;
}

export function OnDemandTeamPageActions({
  canCreateWorkers,
  canUploadWorkers,
  onAddStaffButtonClick,
  exportButton = true,
  disabled = false,
  loading = false,
  exportFilters,
}: Props) {
  const navigate = useNavigate();
  const { isWorkerWithExistingUserEnabled } = useFeatureFlags();

  const items = [
    {
      key: 'create',
      icon: <Icon icon="user" kind="light" />,
      label: 'Create Staff',
    },
    {
      key: 'upload',
      icon: <Icon icon="arrowUpFromBracket" kind="light" />,
      label: 'Upload Staff',
    },
  ];

  const onClick = (item: { key: string }) => {
    if (item.key === 'create' && isWorkerWithExistingUserEnabled) {
      navigate(buildDialogUrl('worker-create-drawer'));
    } else if (item.key === 'create' && !isWorkerWithExistingUserEnabled) {
      onAddStaffButtonClick();
    } else if (item.key === 'upload') {
      navigate('/works/team/on_demand/upload');
    }
  };

  return (
    <>
      <Space size={8}>
        {exportButton && (
          <ExportOnDemandButton
            loading={loading}
            disabled={disabled}
            filters={exportFilters}
          />
        )}
        {canCreateWorkers &&
          !canUploadWorkers &&
          (isWorkerWithExistingUserEnabled ? (
            <Link to={buildDialogUrl('worker-create-drawer')}>
              <AddButton disabled={disabled}>Staff</AddButton>
            </Link>
          ) : (
            <AddButton disabled={disabled} onClick={onAddStaffButtonClick}>
              Staff
            </AddButton>
          ))}
        {canCreateWorkers && canUploadWorkers && (
          <Dropdown
            disabled={disabled}
            menu={{ items, onClick }}
            className="add-staff-dropdown"
            placement="bottomRight"
          >
            <AddButton disabled={disabled} showDropdown>
              Staff
            </AddButton>
          </Dropdown>
        )}
      </Space>
      <style jsx>{`
        :global(.add-staff-dropdown:hover) {
          opacity: 90%;
        }
      `}</style>
    </>
  );
}
